(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name examtemplate.factory:Examtemplate
   *
   * @description
   *
   */
  angular
    .module('vcexamtemplate')
    .factory('Examtemplate', Examtemplate);
  
  
  Examtemplate.$inject = ['restmod'];
  function Examtemplate(restmod) {
    return restmod.model('/routes/examtemplates').mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/examtemplates/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function (key, val) {
            return $search({key, val});
          }
        } // Model
      }// extend
    });
  }
  
// klammerfriedhof
}());
